(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
    class AnnouncementBar extends HTMLElement {
        constructor() {
            super();
            this.elements = {
                button: this.querySelector('button'),
                bar: this.querySelector('.announcement-bar'),
            };
            this.elements.button.addEventListener('click', this.setHide.bind(this));

            const hidden = sessionStorage.getItem('announcement-bar') === 'hidden';

            if (!hidden) {
                this.elements.bar.style.display = 'block';
            }
        }

        setHide(event) {
            this.elements.bar.style.display = 'none';
            sessionStorage.setItem('announcement-bar', 'hidden');
        }
    }

    customElements.define('annoucement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-bottom"]) return;
  try {
    
    let scrolllock = false;
    const dataMainMenuItems = document.querySelectorAll('[data-main-menu-item]');
    const headerBottom = document.querySelector('.header-bottom');
    const menuDesktop = document.querySelector('.header-bottom-menu');
    const menuMobile = document.querySelector('.header-bottom-menu-mobile');
    const menuMobileButton = document.querySelector('.header-bottom-meta-menu-mobile-button');
    const flyoutCart = document.querySelector('.header-bottom-flyout-cart');
    const flyoutCartButton = document.querySelector('.header-bottom-flyout-cart-button');
    const flyoutCartButtonClose = document.querySelector('.header-bottom-flyout-cart-button-close');

    const setInputDevice = (device) => {
        dataMainMenuItems.forEach((item) => {
            item.dataset.inputDevice = device;
        });
    };

    const setSize = () => {
        if (scrolllock) {
            return;
        }

        scrolllock = true;

        const rect = headerBottom.getBoundingClientRect();
        const offset = rect.top + rect.height;
        headerBottom.style.cssText = `--offset: ${offset}px`;
        menuDesktop.style.cssText = `--offset: ${offset}px`;
        menuMobile.style.cssText = `--offset: ${offset}px`;

        scrolllock = false;
    };

    const setToggleMenuMobile = () => {
        console.log('toggle menu mobile');

        if (menuMobile.open) {
            menuMobile.close();
            menuMobileButton.dataset.open = false;
            return;
        }

        menuMobile.show();
        menuMobileButton.dataset.open = true;
    };

    const setCloseFlyoutCart = () => flyoutCart.close();
    const setShowFlyoutCart = () => flyoutCart.show();

    dataMainMenuItems.forEach((item) => {
        item.addEventListener('mouseenter', () => setInputDevice('mouse'));
        item.addEventListener('focusin', () => setInputDevice('keyboard'));
    });

    menuMobileButton.addEventListener('click', setToggleMenuMobile);
    flyoutCartButtonClose.addEventListener('click', setCloseFlyoutCart);
    flyoutCartButton.addEventListener('click', setShowFlyoutCart);

    window.addEventListener('scroll', () => setSize(), { passive: true });
    window.addEventListener('resize', () => setSize(), { passive: true });
    window.addEventListener('load', () => setSize(), { passive: true });

    if (window.location.hash === '#show-cart') {
        setShowFlyoutCart();
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
    window.onload = () =>
        new Splide('.splide', {
            type: 'loop',
            arrows: false,
            classes: {
                pagination: 'splide__pagination slider-pagination',
                page: 'splide__pagination__page slider-pagination-page',
            },
        }).mount();

    const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(productRecommendationsSection);

        const url = productRecommendationsSection.dataset.url;

        fetch(url)
            .then((response) => response.text())
            .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.product-recommendations');

                if (recommendations && recommendations.innerHTML.trim().length) {
                    productRecommendationsSection.innerHTML = recommendations.innerHTML;
                }
            })
            .catch((e) => {
                console.error(e);
            });
    };

    const productRecommendationsSection = document.querySelector('.product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

    observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
